/*    在组件内需要调用，可以通过VUEX的MAP辅助函数
 *   import { mapState, mapMutations, mapActions } from 'vuex'
 *   ...mapState ('user',['id'])                   // 获取state值{{this.id}}
 *   ...mapMutations('user', ['updateId'])         // 不通过异步来修改 this.UpdateId(value) 改变state值
 *
 *
 *这里用了localStorag存放state的值,解决了刷新浏览器所有状态都会初始化。
 *在某些浏览器上用户关闭了本地存储或者使用隐身模式，会导致浏览器抛出异常
 *如果用了本地存储，在外层包裹上try{}catch(e){}
 */
import Vue from 'vue'
function getCookie(name) {
	var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)"); //匹配字段
	if (arr = document.cookie.match(reg)) {
		return decodeURIComponent(arr[2]);
	} else {
		return null;
	}
}

let defaultAccountId = null
let defaultUserId = null
let defaultTenantId = null
let defaultRealName = ''
let defaultMobile = ''
let defaultIsOuter = null
let defaultAvatarUrl = ''
let defaultIsLogin = false
try {
  defaultAccountId = getCookie('accountId')
  defaultUserId = getCookie('userId')
  defaultTenantId = getCookie('tenantId')
  defaultRealName = getCookie('realName')
  defaultMobile = getCookie('mobile')
  defaultIsOuter = getCookie('isOuter')
  defaultAvatarUrl = getCookie('avatarUrl')
  defaultIsLogin = !!getCookie('token')
} catch (e) {

}
const user = {
  namespaced: true,
  state: {
    // 账号id, 存于：登录；用于：获取租户信息
    accountId: defaultAccountId,
    // 用户id, 存于：登录写入租户后；用于：获取菜单等
    userId: defaultUserId,
    // 租户id, 存于：登录写入租户后；
    tenantId: defaultTenantId,
    // 实名, 存于：登录；用于：顶部显示
    realName: defaultRealName,
    // 手机号, 存于登录；用于：水印等
    mobile: defaultMobile,
    // 是否外部账号, 存于登录写入租户；
    isOuter: defaultIsOuter,
    // 头像地址, 存于登录写入租户后；用于顶部显示
    avatarUrl: defaultAvatarUrl,

    // 认证公司名称，存于获取企业认证信息；用于取保理数据等
    companyName: '',
    // 认证企业统一社会信用代码，存于企业认证信息；用于额度申请等
    companyNo: '',
    // 组织id
    // 来源：认证信息
    // 用处：获取当前认证组织下的用户
    orgId: null,
    // 个人签章生份证号
    // 来源：个人签约列表获取前先获取个人签章信息
    // 用处：获取个人签约列表等
    idCardNo: null,
    // 租户名称，存于顶部租户展示查询，用于某些页面
    tenantName: '',
    isLogin: defaultIsLogin,
  },
  mutations: {
    updateAccountId (state, id) {
      state.accountId = id
      try {
        Vue.cookie.set('accountId', id)
      } catch (e) { }
    },
    updateUserId (state, id) {
      state.userId = id
      try {
        Vue.cookie.set('userId', id)
      } catch (e) { }
    },
    updateTenantId (state, id) {
      state.tenantId = id
      try {
        Vue.cookie.set('tenantId', id)
      } catch (e) { }
    },
    updateRealName (state, name) {
      state.realName = name
      try {
        Vue.cookie.set('realName', name)
      } catch (e) { }
    },
    updateMobile (state, mobile) {
      state.mobile = mobile
      try {
        Vue.cookie.set('mobile', mobile)
      } catch (e) { }
    },
    updateIsOuter (state, isOuter) {
      state.isOuter = isOuter
      try {
        Vue.cookie.set('isOuter', isOuter)
      } catch (e) { }
    },
    updateAvatarUrl (state, url) {
      state.avatarUrl = url
      try {
        Vue.cookie.set('avatarUrl', url)
      } catch (e) { }
    },

    updateIsLogin (state, bool) {
      state.isLogin = bool
    },

    updateCompanyName (state, name) {
      state.companyName = name
      try {
        localStorage.companyName = name
      } catch (e) { }
    },
    updateCompanyNo (state, no) {
      state.companyNo = no
      try {
        localStorage.companyNo = no
      } catch (e) { }
    },
    updateOrgId (state, id) {
      state.orgId = id
    },
    updateIdCardNo (state, id) {
      state.idCardNo = id
    },
    updateTenantName (state, name) {
      state.tenantName = name
      try {
        localStorage.tenantName = name
      } catch (e) { }
    }
  },
  actions: {
    ActionsAccountId (ctx, value) {
      ctx.commit('updateAccountId', value)
    },
    ActionsUserId (ctx, value) {
      ctx.commit('updateUserId', value)
    },
    ActionsTenantId (ctx, value) {
      ctx.commit('updateTenantId', value)
    },
    ActionsRealName (ctx, value) {
      ctx.commit('updateRealName', value)
    },
    ActionsMobile (ctx, value) {
      ctx.commit('updateMobile', value)
    },
    ActionsIsOuter (ctx, value) {
      ctx.commit('updateIsOuter', value)
    },
    ActionsAvatarUrl (ctx, value) {
      ctx.commit('updateAvatarUrl', value)
    },
    
    ActionsAccountId (ctx, value) {
      ctx.commit('updateAccountId', value)
    },
    ActionsTenantName (ctx, value) {
      ctx.commit('updateTenantName', value)
    }
  }
}
export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js